// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-section-wrapper-psp {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1440px;
  width: 100%;
  color: #fff;
}
.footer-section-wrapper-psp .footer-wave-wrapper {
  width: 100%;
}
.footer-section-wrapper-psp .footer-wave-wrapper svg {
  width: 100%;
  height: fit-content;
}
.footer-section-wrapper-psp .footer-body-section-wrapper {
  width: 100%;
  background-color: #172C48;
  margin-top: -1px;
  padding: 60px 5vw;
  padding-bottom: 50px;
  display: flex;
  gap: 30px;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left {
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 60%;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-logo-wrapper {
  display: flex;
  align-items: center;
  gap: 24px;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-logo-wrapper > img {
  width: 120px;
  height: 120px;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-logo-wrapper > div {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-logo-wrapper > div span {
  font-family: "Playfair Display", sans-serif !important;
  font-weight: 500;
  text-align: left;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-logo-wrapper > div > span:first-child {
  font-size: 32px;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-logo-wrapper > div > span:last-child {
  font-size: 24px;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-about-cordelia {
  font-size: 20px;
  font-weight: 400;
  text-align: left;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-social-media-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-contact-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-contact-wrapper span {
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 24px;
  font-weight: 600;
  text-align: left;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-contact-wrapper span a {
  font-family: "Playfair Display", sans-serif !important;
  text-decoration: none;
  color: #fff;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-middle, .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-right {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 20%;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-middle > span, .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-right > span {
  font-family: "Playfair Display", sans-serif !important;
  font-size: 28px;
  font-weight: 700;
  text-align: left;
  color: #F16F5B;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-middle > div, .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-right > div {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-middle > div a, .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-right > div a {
  text-decoration: none;
  font-size: 20px;
  font-weight: 400;
  color: #fff;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .mobile-screen-social-media-wrapper {
  display: none;
  align-items: center;
  gap: 60px;
  padding: 20px 0;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .mobile-screen-social-media-wrapper span {
  font-family: "Playfair Display", sans-serif !important;
  font-size: 22px;
  font-weight: 400;
}
.footer-section-wrapper-psp .footer-body-section-wrapper .mobile-screen-social-media-wrapper > div {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
}
.footer-section-wrapper-psp .copyright-text-footer-psp {
  font-family: "Playfair Display", sans-serif !important;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #000;
  margin: 0;
  padding: 12px 10px;
}

.accordion-wrapper-psp {
  display: none;
}
.accordion-wrapper-psp > span {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  font-family: "Playfair Display", sans-serif !important;
  font-size: 22px;
  font-weight: 400;
  color: #F16F5B;
  padding-right: 12px;
}
.accordion-wrapper-psp > span.open svg {
  transform: rotate(90deg);
}
.accordion-wrapper-psp > span.close svg {
  transform: rotate(-90deg);
}
.accordion-wrapper-psp .accordion-content-psp {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  border-bottom: 1px solid #ddd;
}
.accordion-wrapper-psp .accordion-content-psp a {
  text-decoration: none;
  font-size: 18px;
  font-weight: 400;
  color: #fff;
}
.accordion-wrapper-psp .accordion-content-psp a:last-of-type {
  margin-bottom: 20px;
}
.accordion-wrapper-psp .accordion-content-psp.active {
  max-height: 450px;
  transition: max-height 0.3s ease-in;
}

@media only screen and (width <= 1024px) {
  .footer-section-wrapper-psp .footer-body-section-wrapper {
    flex-direction: column;
    gap: 0;
    padding-bottom: 0;
  }
  .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left {
    width: 100%;
    border-bottom: 1px solid #ddd;
    padding-bottom: 26px;
  }
  .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-social-media-wrapper {
    display: none;
  }
  .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-middle, .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-right {
    display: none;
  }
  .footer-section-wrapper-psp .footer-body-section-wrapper .mobile-screen-social-media-wrapper {
    display: flex;
  }
  .accordion-wrapper-psp {
    display: block;
  }
}
@media only screen and (width <= 510px) {
  .footer-section-wrapper-psp .footer-body-section-wrapper {
    padding: 20px 20px;
  }
  .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-logo-wrapper > div > span:first-child {
    font-size: 24px;
  }
  .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-logo-wrapper > div > span:last-child {
    font-size: 20px;
  }
  .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-about-cordelia {
    font-size: 16px;
  }
  .footer-section-wrapper-psp .footer-body-section-wrapper .footer-body-section-left .footer-body-section-left-contact-wrapper span {
    font-size: 18px;
  }
  .footer-section-wrapper-psp .footer-body-section-wrapper .mobile-screen-social-media-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/PaymentStatusPage/components/FooterSectionPSP/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;AACJ;AACI;EACI,WAAA;AACR;AACQ;EACI,WAAA;EACA,mBAAA;AACZ;AAGI;EACI,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;AADR;AAGQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AADZ;AAGY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AADhB;AAGgB;EACI,YAAA;EACA,aAAA;AADpB;AAIgB;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAFpB;AAIoB;EACI,sDAAA;EACA,gBAAA;EACA,gBAAA;AAFxB;AAKoB;EACI,eAAA;AAHxB;AAMoB;EACI,eAAA;AAJxB;AASY;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAPhB;AAUY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AARhB;AAWY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAThB;AAWgB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AATpB;AAWoB;EACI,sDAAA;EACA,qBAAA;EACA,WAAA;AATxB;AAeQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AAbZ;AAeY;EACI,sDAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAbhB;AAgBY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAdhB;AAgBgB;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAdpB;AAmBQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAjBZ;AAmBY;EACI,sDAAA;EACA,eAAA;EACA,gBAAA;AAjBhB;AAoBY;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAlBhB;AAuBI;EACI,sDAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AArBR;;AAyBA;EACI,aAAA;AAtBJ;AAuBI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,sDAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AArBR;AAwBY;EACI,wBAAA;AAtBhB;AA2BY;EACI,yBAAA;AAzBhB;AA8BI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,oCAAA;EACA,6BAAA;AA5BR;AA8BQ;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA5BZ;AA+BQ;EACC,mBAAA;AA7BT;AAgCQ;EACI,iBAAA;EACA,mCAAA;AA9BZ;;AAmCA;EAEQ;IACI,sBAAA;IACA,MAAA;IACA,iBAAA;EAjCV;EAkCU;IACI,WAAA;IACA,6BAAA;IACA,oBAAA;EAhCd;EAkCc;IACI,aAAA;EAhClB;EAmCU;IACI,aAAA;EAjCd;EAoCU;IACI,aAAA;EAlCd;EAwCE;IACI,cAAA;EAtCN;AACF;AAyCA;EAES;IACG,kBAAA;EAxCV;EA4CsB;IACI,eAAA;EA1C1B;EA6CsB;IACI,eAAA;EA3C1B;EAgDc;IACI,eAAA;EA9ClB;EAkDkB;IACI,eAAA;EAhDtB;EAoDU;IACI,aAAA;IACA,8BAAA;IACA,MAAA;EAlDd;AACF","sourcesContent":[".footer-section-wrapper-psp {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    max-width: 1440px;\n    width: 100%;\n    color: #fff;\n\n    .footer-wave-wrapper {\n        width: 100%;\n\n        svg {\n            width: 100%;\n            height: fit-content;\n        }\n    }\n\n    .footer-body-section-wrapper {\n        width: 100%;\n        background-color: #172C48;\n        margin-top: -1px;\n        padding: 60px 5vw;\n        padding-bottom: 50px;\n        display: flex;\n        gap: 30px;\n\n        .footer-body-section-left {\n            display: flex;\n            flex-direction: column;\n            gap: 28px;\n            width: 60%;\n\n            .footer-body-section-left-logo-wrapper {\n                display: flex;\n                align-items: center;\n                gap: 24px;\n\n                >img {\n                    width: 120px;\n                    height: 120px;\n                }\n\n                >div {\n                    display: flex;\n                    flex-direction: column;\n                    gap: 10px;\n\n                    span {\n                        font-family: 'Playfair Display', sans-serif !important;\n                        font-weight: 500;\n                        text-align: left;\n                    }\n\n                    >span:first-child {\n                        font-size: 32px;\n                    }\n\n                    >span:last-child {\n                        font-size: 24px;\n                    }\n                }\n            }\n\n            .footer-body-section-left-about-cordelia {\n                font-size: 20px;\n                font-weight: 400;\n                text-align: left;\n            }\n\n            .footer-body-section-left-social-media-wrapper{\n                display: flex;\n                align-items: center;\n                gap: 20px;\n            }\n\n            .footer-body-section-left-contact-wrapper{\n                display: flex;\n                flex-direction: column;\n                gap: 16px;\n\n                span{\n                    display: flex;\n                    align-items: center;\n                    gap: 18px;\n                    font-size: 24px;\n                    font-weight: 600;\n                    text-align: left;\n                    \n                    a{\n                        font-family: 'Playfair Display', sans-serif !important;\n                        text-decoration: none;\n                        color: #fff;\n                    }\n                }\n            }\n        }\n\n        .footer-body-section-middle, .footer-body-section-right{\n            display: flex;\n            flex-direction: column;\n            gap: 18px;\n            width: 20%;\n\n            >span {\n                font-family: 'Playfair Display', sans-serif !important;\n                font-size: 28px;\n                font-weight: 700;\n                text-align: left;\n                color: #F16F5B;\n            }\n\n            >div{\n                display: flex;\n                flex-direction: column;\n                gap: 12px;\n\n                a{\n                    text-decoration: none;\n                    font-size: 20px;\n                    font-weight: 400;\n                    color: #fff;\n                }\n            }\n        }\n\n        .mobile-screen-social-media-wrapper{\n            display: none;\n            align-items: center;\n            gap: 60px;\n            padding: 20px 0;\n\n            span{\n                font-family: 'Playfair Display', sans-serif !important;\n                font-size: 22px;\n                font-weight: 400;\n            }\n\n            >div{\n                display: flex;\n                flex-wrap: wrap;\n                gap: 20px;\n                align-items: center;\n            }\n        }\n    }\n\n    .copyright-text-footer-psp{\n        font-family: 'Playfair Display', sans-serif !important;\n        font-size: 16px;\n        font-weight: 400;\n        text-align: center;\n        color: #000;\n        margin: 0;\n        padding: 12px 10px;\n    }\n}\n\n.accordion-wrapper-psp{\n    display: none;\n    >span {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 20px 0;\n        font-family: 'Playfair Display', sans-serif !important;\n        font-size: 22px;\n        font-weight: 400;\n        color: #F16F5B;\n        padding-right: 12px;\n\n        &.open {\n            svg{\n                transform: rotate(90deg);\n            }\n        }\n\n        &.close {\n            svg{\n                transform: rotate(-90deg);\n            }\n        }\n    }\n\n    .accordion-content-psp {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n        max-height: 0;\n        overflow: hidden;\n        transition: max-height 0.3s ease-out;\n        border-bottom: 1px solid #ddd;\n    \n        a {\n            text-decoration: none;\n            font-size: 18px;\n            font-weight: 400;\n            color: #fff;\n        }\n\n        a:last-of-type{\n         margin-bottom: 20px;\n        }\n    \n        &.active {\n            max-height: 450px;\n            transition: max-height 0.3s ease-in;\n        }\n    }\n}\n\n@media only screen and (width <= 1024px){\n    .footer-section-wrapper-psp {  \n        .footer-body-section-wrapper {\n            flex-direction: column;\n            gap: 0;\n            padding-bottom: 0;\n            .footer-body-section-left{\n                width: 100%;\n                border-bottom: 1px solid #ddd;\n                padding-bottom: 26px;\n\n                .footer-body-section-left-social-media-wrapper{\n                    display: none;\n                }\n            }\n            .footer-body-section-middle, .footer-body-section-right{\n                display: none;\n            }\n\n            .mobile-screen-social-media-wrapper{\n                display: flex;\n            }\n        }\n\n    }\n\n    .accordion-wrapper-psp{\n        display: block;\n    }\n}\n\n@media only screen and (width <= 510px) {\n    .footer-section-wrapper-psp {\n         .footer-body-section-wrapper {\n            padding: 20px 20px;\n            .footer-body-section-left {\n                .footer-body-section-left-logo-wrapper {    \n                    >div {    \n                        >span:first-child {\n                            font-size: 24px;\n                        }\n    \n                        >span:last-child {\n                            font-size: 20px;\n                        }\n                    }\n                }\n\n                .footer-body-section-left-about-cordelia {\n                    font-size: 16px;\n                }\n\n                .footer-body-section-left-contact-wrapper{    \n                    span{\n                        font-size: 18px;\n                    }\n                }\n            }\n            .mobile-screen-social-media-wrapper{\n                display: flex;\n                justify-content: space-between;\n                gap: 0;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
